'use strict'

export default (mockAxios) => {
  // 操作ログ一覧取得
  mockAxios.onPost(`/access-logs`).reply(200, {
    'success': true,
    'data': [
      {
        'sid_corporate': 1,
        'id': 1,
        'formatted_datetime': '2020/07/30 01:23:45',
        'category': 'b',
        'lang_category': '名刺詳細の閲覧',
        'target_user_id': 11,
        'target_user': {
          'sid_corporate': 1,
          'id': 11,
          'full_name': '山田 太郎'
        },
        'login_user_id': null,
        'login_user': null
      },
      {
        'sid_corporate': 1,
        'id': 2,
        'formatted_datetime': '2020/07/30 00:11:22',
        'category': 'b',
        'lang_category': '名刺詳細の閲覧',
        'target_user_id': 13,
        'target_user': {
          'sid_corporate': 1,
          'id': 13,
          'full_name': '森本 りりか'
        },
        'login_user_id': null,
        'login_user': null
      },
      {
        'sid_corporate': 1,
        'id': 3,
        'formatted_datetime': '2020/07/29 05:55:55',
        'category': 'a',
        'lang_category': '名刺一覧の閲覧',
        'target_user_id': 10,
        'target_user': {
          'sid_corporate': 1,
          'id': 10,
          'full_name': '柳田 誠二'
        },
        'login_user_id': 11,
        'login_user': {
          'sid_corporate': 1,
          'id': 11,
          'full_name': '山田 太郎'
        }
      },
      {
        'sid_corporate': 1,
        'id': 4,
        'formatted_datetime': '2020/07/29 01:23:45',
        'category': 'd',
        'lang_category': '名刺情報のエクスポート',
        'target_user_id': 11,
        'target_user': {
          'sid_corporate': 1,
          'id': 11,
          'full_name': '山田 太郎'
        },
        'login_user_id': 12,
        'login_user': {
          'sid_corporate': 1,
          'id': 12,
          'full_name': '新井 真一'
        }
      },
      {
        'sid_corporate': 1,
        'id': 5,
        'formatted_datetime': '2020/07/29 00:11:22',
        'category': 'c',
        'lang_category': '名刺情報のインポート',
        'target_user_id': 11,
        'target_user': {
          'sid_corporate': 1,
          'id': 11,
          'full_name': '山田 太郎'
        },
        'login_user_id': null,
        'login_user': null
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 操作ログ詳細取得
  mockAxios.onGet(new RegExp(`/access-logs/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'sid_corporate': 1,
      'id': 4,
      'formatted_datetime': '2020/07/29 01:23:45',
      'category': 'd',
      'lang_category': '名刺情報のエクスポート',
      'target_user_id': 11,
      'target_user': {
        'sid_corporate': 1,
        'id': 11,
        'full_name': '山田 太郎'
      },
      'login_user_id': 12,
      'login_user': {
        'sid_corporate': 1,
        'id': 12,
        'full_name': '新井 真一'
      },
      'log': '2020-07-29 01:23:45 Info: USER[...] METHOD[...] URL[...] QUERY[...] BODY[...] DATA[...]'
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/accessLogRepositoryMock.js